<div class="main-container">
  <div class="cards">
    <div class="drawer-card">
      <div class="drawer-card-header">
        Warehouse
        <span class="drawer-card-badge"
          >Ship to {{ platformAccount()?.address?.zip }}</span
        >
      </div>
      <div class="drawer-card-body">
        <mat-form-field class="warehouse-select">
          <mat-label>Warehouse</mat-label>
          <mat-select
            [value]="defaultWarehouse()?.city"
            (selectionChange)="selectedWarehouse($event.value)"
          >
            @for (option of warehouseOptions; track option) {
              <mat-option [value]="option.city">
                {{ option.city }}, {{ option.state }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>

        @if (parcelLoader() && parcelInfo() === undefined) {
          <spinner></spinner>
        } @else {
          @if (parcelInfo()?.length === 0) {
            <div class="empty">None on file</div>
          } @else {
            <div class="service-grid">
              <span class="col-head">Service</span>
              <span class="col-head">UPS</span>
              <span class="col-head">FedEx</span>
              @for (row of cutoffRows(); track row.label) {
                <span class="service-name">{{ row.label }}</span>
                <span>{{ row.ups }}</span>
                <span>{{ row.fedex }}</span>
              }
            </div>
          }
        }
      </div>
    </div>

    <div class="drawer-card">
      <div class="drawer-card-header">
        Carriers
        <span class="drawer-card-badge">Default {{ preferredCarrier() }}</span>
        <button
          type="button"
          class="refresh-button"
          [class.spinning]="isRefreshing()"
          (click)="manualRefresh()"
          aria-label="Refresh shipping data"
          title="Refresh shipping data"
        >
          ⟳
        </button>
      </div>
      <div class="drawer-card-body">
        @if (deliveryDaysLoader() && deliveryDays() === undefined) {
          <spinner></spinner>
        } @else {
          @if (deliveryDays()?.length === 0) {
            <div class="empty">None on file</div>
          } @else {
            <div class="status-list">
              <div class="status-row">
                <i
                  class="status-dot"
                  [ngClass]="getCarrierShipStatus('UP', 'GROUND').colorClass"
                  [matTooltip]="getCarrierShipStatus('UP', 'GROUND').toolTip"
                  matTooltipPosition="above"
                ></i>
                <span
                  >UPS Ground {{ getCarrierShipDays("UPS", "Ground") }}</span
                >
                <span class="status-text">{{
                  getCarrierShipStatus("UP", "GROUND").toolTip
                }}</span>
              </div>
              <div class="status-row">
                <i
                  class="status-dot"
                  [ngClass]="getCarrierShipStatus('UP', 'AIR').colorClass"
                  [matTooltip]="getCarrierShipStatus('UP', 'AIR').toolTip"
                  matTooltipPosition="above"
                ></i>
                <span>UPS Air</span>
                <span class="status-text">{{
                  getCarrierShipStatus("UP", "AIR").toolTip
                }}</span>
              </div>
              <div class="status-row">
                <i
                  class="status-dot"
                  [ngClass]="getCarrierShipStatus('FX', 'GROUND').colorClass"
                  [matTooltip]="getCarrierShipStatus('FX', 'GROUND').toolTip"
                  matTooltipPosition="above"
                ></i>
                <span
                  >FedEx Ground
                  {{ getCarrierShipDays("Fedex", "Ground") }}</span
                >
                <span class="status-text">{{
                  getCarrierShipStatus("FX", "GROUND").toolTip
                }}</span>
              </div>
              <div class="status-row">
                <i
                  class="status-dot"
                  [ngClass]="getCarrierShipStatus('FX', 'AIR').colorClass"
                  [matTooltip]="getCarrierShipStatus('FX', 'AIR').toolTip"
                  matTooltipPosition="above"
                ></i>
                <span>FedEx Air</span>
                <span class="status-text">{{
                  getCarrierShipStatus("FX", "AIR").toolTip
                }}</span>
              </div>
            </div>
          }
        }
      </div>
    </div>

    <div class="drawer-card">
      <div class="drawer-card-header">
        Delivery Vans
        @if (getTimezone(); as timezone) {
          <span class="drawer-card-badge">Times in {{ timezone }}</span>
        }
      </div>
      <div class="drawer-card-body">
        @if (deliveryVanLoader() && deliveryVans() === undefined) {
          <spinner></spinner>
        } @else {
          <!-- EXT-6537: one compact Type / Cutoff / Arrive / Driver table,
               with the return cutoffs on one line beneath it. -->
          <div class="van-grid">
            <span class="col-head">Type</span>
            <span class="col-head">Cutoff</span>
            <span class="col-head">Arrive</span>
            <span class="col-head">Driver</span>
            @for (row of deliveryVans(); track $index) {
              <span>{{ row.deliveryPickup }}</span>
              <span
                [matTooltip]="
                  row.isPickup ? 'Pickups cannot be used for deliveries' : ''
                "
                [ngClass]="row.isPickup ? 'underline' : ''"
                matTooltipPosition="above"
              >
                {{
                  convertISOToPrettyTimeLocal(
                    row.cutOff,
                    platformAccount()?.address?.state!
                  )
                }}
              </span>
              <span>{{ convertDateToPrettyDay(row.arrivalDate) }}</span>
              <!-- DB2 CHAR columns arrive space-padded, so an "empty" driver
                   is a run of spaces -- truthy, which defeats a plain `|| "—"`. -->
              <span
                >{{ row.driver.trim() || "—" }}
                @if (row.phone.trim(); as phone) {
                  <br /><span class="dim">{{ phone }}</span>
                }
              </span>
            }
          </div>

          @if (returnCutOffs()) {
            <div class="return-cutoffs">
              <strong>Return cutoff</strong>
              <span
                >Thu {{ getCutoffStatus(returnCutOffs()?.THURSDAY_RUN) }}</span
              >
              <span
                >Fri {{ getCutoffStatus(returnCutOffs()?.FRIDAY_RUN) }}</span
              >
              <span
                >Sat {{ getCutoffStatus(returnCutOffs()?.SATURDAY_RUN) }}</span
              >
            </div>
          }

          @if (returnCutOffs()?.SAT_NAME) {
            <div class="kv-grid bordered-top">
              <span class="label">Saturday Delivery</span>
              <span>
                {{ returnCutOffs()?.SAT_NAME }}<br />
                {{ returnCutOffs()?.SAT_ADR1 }}<br />
                @if (returnCutOffs()?.SAT_ADR2) {
                  {{ returnCutOffs()?.SAT_ADR2 }}<br />
                }
                {{ returnCutOffs()?.SAT_CITY }}
              </span>
            </div>
          }
        }
      </div>
    </div>

    <div class="drawer-card">
      <div class="drawer-card-header">Shipping Instructions</div>
      <div class="drawer-card-body">
        @if (
          shippingInstructionsLoader() && shippingInstructions() === undefined
        ) {
          <spinner></spinner>
        } @else {
          @if (!shippingInstructions()?.length) {
            <div class="empty">None on file</div>
          } @else {
            @for (shippingInstruction of shippingInstructions(); track $index) {
              <div>{{ shippingInstruction.TEXT }}</div>
            }
          }
        }
      </div>
    </div>
  </div>
</div>
